import { getConfigDetails } from '../../services/config'

export const getConfig = () => {
	const partner = localStorage.getItem('partnerData') ? JSON.parse(localStorage.getItem('partnerData')) : {}

	const configDetails = getConfigDetails()
	if (!configDetails || !configDetails?.baseURL) {
		console.error('getConfigDetails() returned invalid config:', configDetails)
		throw new Error('Invalid configuration: baseURL is missing')
	}

	const mainBaseUrl = configDetails?.baseURL
	const baseUrl = partner?.api_config?.url ? partner?.api_config?.url : configDetails?.baseURL

	return {
		// Diamond parking api start 
		getUserLoginUrl: `${baseUrl}oauth/access_token`,
		getFacilityListUrl: `${baseUrl}facility_llc`,
		getFacilityList: `${baseUrl}diamond-permit-partner-facility`,
		getPermitRateListUrl: `${baseUrl}diamond-partner-permit-rates`,

		// Permit PARTNER PERMIT RATES
		getArePermitRateListUrl: `${baseUrl}are-partner-permit-rates`,
		getProRateListUrl: `${baseUrl}diamond-partner-pro-rate`,

		// Permit PRO RATES
		getAreProRateListUrl: `${baseUrl}are-partner-pro-rate`,
		getPermitDataUrl: `${baseUrl}get-user-all-permits`,
		getActivePermitDataUrl: `${baseUrl}active-permit-list`,

		// Card details api start 
		// getCardDataUrl: `${baseUrl}list-payment-methods`,
		// createCardUrl: `${baseUrl}membership-payment-method`,
		// removeCardUrl: `${baseUrl}delete-membership-payment-method`,

		// getCardDataUrl: `${baseUrl}get-planet-profile`,
		// createCardUrl: `${baseUrl}add-planet-profile`,
		// removeCardUrl: `${baseUrl}delete-planet-profile`,

		createCardUrl: `${baseUrl}add-card-profile`,
		getCardDataUrl: `${baseUrl}get-card-profile`,
		removeCardUrl: `${baseUrl}delete-card-profile`,



		// booking history

		getBookingHistroyDataUrl: `${baseUrl}get-user-booking`,

		getVehicleListUrl: `${baseUrl}get-vehicle-list`,
		postVehicleListUrl: `${baseUrl}add-vehicle`,
		postVehicleUpdateUrl: `${baseUrl}update-vehicle-details`,
		deleteVehicleItemUrl: `${baseUrl}delete-vehicle`,
		getWaitingListUrl: `${baseUrl}wait-list-user-update`,
		getBookingUrl: `${baseUrl}book-permit`,
		getVehicleModelUrl: `${baseUrl}get-all-make-models`,

		//BOOKPERMIT FOR Permit-Staging
		getAreBookingUrl: `${baseUrl}book-permit-are`,

		// UPDATED USER PROFILE
		updateUserProfileUrl: `${baseUrl}diamond-update-profile`,
		// Get user profile
		getUserProfileUrl: `${baseUrl}diamond-get-user-by-id`,

		//PASSLIST API
		getPassListUrl: `${baseUrl}get-partner-user-passes`,

		// Reset Password
		postRestPassword: `${baseUrl}reset-are-password`,

		resetPassword: `${configDetails?.baseURL}user/reset-password`,

		getFacilityPass: `${baseUrl}get-user-facility-pass`,

		getArePassUrl: `${baseUrl}book-pass-are`,

		getPaymentInitialUrl: `${baseUrl}are-planet-payment-session`,
		saveBookingBeforePaymentUrl: `${baseUrl}are-booking-before-payment`,
		permitBookingURL: `${baseUrl}permit-booking`,
		cancelPermitUrl: `${baseUrl}cancel-permit-by-user-new`,
		cancelPermitUrlRenew: `${baseUrl}cancel-permit-by-user`,
		permitTokenPaymentUrl: `${baseUrl}are-payment`,
		saveBookingafterPaymentUrl: `${baseUrl}are-booking-after-payment`,
		//pass
		getPassPaymentInitialUrl: `${baseUrl}userpass-planet-payment-session`,
		savePassBookingBeforePaymentUrl: `${baseUrl}userpass-before-payment`,
		userPassTokenPaymentUrl: `${baseUrl}userpass-payment`,
		savePassBookingafterPaymentUrl: `${baseUrl}userpass-after-payment`,

		// Get user profile
		getUserProfileData: `${baseUrl}api`,



		// AAA API's

		// timeZone: 'America/New_York',
		//timeZone: 'America/Los_Angeles',
		defaultBookingLength: 24,
		clientSecret: configDetails?.CLIENT_SECRET,
		encryptKey: 'Tw5qNOJLe5GFe7rjFsentNNQBsRHstbNzTP/18lkjnY=',
		getPassesReqUrl: `${baseUrl}rate-pass`,
		getUserPassesReqUrl: `${baseUrl}user-passes`,
		getPartnerDetailsReqUrl: `${baseUrl}partners-key-by-secret`,
		paymentReqUrl: `${baseUrl}reservation`,
		verifyMemberReqUrl: `${baseUrl}verify-member-user`,
		getGaragePriceUrl: `${baseUrl}rate/facility-on-marker`,
		eventLogUrl: `${baseUrl}addUserEvent`,
		getPaymentSessionUrl: `${baseUrl}atlanta-planet-payment-session`,
		getReservationUrl: `${baseUrl}atlanta-reservation`,
		// getBeforePayment: `${config.baseURL}/atlanta-booking-before-payment`,
		getChecksUrl: `${baseUrl}check-booking-before-payment`,
		getAfterPayment: `${baseUrl}aaa-booking-after-payment`,
		getPassDetails: `${baseUrl}get-partner-user-passes-Byid`,
		getPermitDetails: `${baseUrl}are-permit-details`,
		getPermitQr: `${baseUrl}permit-pdf-QRCode`,

		timeDropDown: [
			{ value: '00:00:00', time: '12:00 AM' }, { value: '00:30:00', time: '12:30 AM' },
			{ value: '01:00:00', time: '01:00 AM' }, { value: '01:30:00', time: '01:30 AM' },
			{ value: '02:00:00', time: '02:00 AM' }, { value: '02:30:00', time: '02:30 AM' },
			{ value: '03:00:00', time: '03:00 AM' }, { value: '03:30:00', time: '03:30 AM' },
			{ value: '04:00:00', time: '04:00 AM' }, { value: '04:30:00', time: '04:30 AM' },
			{ value: '05:00:00', time: '05:00 AM' }, { value: '05:30:00', time: '05:30 AM' },
			{ value: '06:00:00', time: '06:00 AM' }, { value: '06:30:00', time: '06:30 AM' },
			{ value: '07:00:00', time: '07:00 AM' }, { value: '07:30:00', time: '07:30 AM' },
			{ value: '08:00:00', time: '08:00 AM' }, { value: '08:30:00', time: '08:30 AM' },
			{ value: '09:00:00', time: '09:00 AM' }, { value: '09:30:00', time: '09:30 AM' },
			{ value: '10:00:00', time: '10:00 AM' }, { value: '10:30:00', time: '10:30 AM' },
			{ value: '11:00:00', time: '11:00 AM' }, { value: '11:30:00', time: '11:30 AM' },
			{ value: '12:00:00', time: '12:00 PM' }, { value: '12:30:00', time: '12:30 PM' },
			{ value: '13:00:00', time: '01:00 PM' }, { value: '13:30:00', time: '01:30 PM' },
			{ value: '14:00:00', time: '02:00 PM' }, { value: '14:30:00', time: '02:30 PM' },
			{ value: '15:00:00', time: '03:00 PM' }, { value: '15:30:00', time: '03:30 PM' },
			{ value: '16:00:00', time: '04:00 PM' }, { value: '16:30:00', time: '04:30 PM' },
			{ value: '17:00:00', time: '05:00 PM' }, { value: '17:30:00', time: '05:30 PM' },
			{ value: '18:00:00', time: '06:00 PM' }, { value: '18:30:00', time: '06:30 PM' },
			{ value: '19:00:00', time: '07:00 PM' }, { value: '19:30:00', time: '07:30 PM' },
			{ value: '20:00:00', time: '08:00 PM' }, { value: '20:30:00', time: '08:30 PM' },
			{ value: '21:00:00', time: '09:00 PM' }, { value: '21:30:00', time: '09:30 PM' },
			{ value: '22:00:00', time: '10:00 PM' }, { value: '22:30:00', time: '10:30 PM' },
			{ value: '23:00:00', time: '11:00 PM' }, { value: '23:30:00', time: '11:30 PM' }
		],


		getUserDetailUrl: `${configDetails?.baseURL}search-ticket-number`,
		getSearchTicketUrl: `${configDetails?.baseURL}get-receipt-ticket-details`,
		downloadEticketUrl: `${configDetails?.baseURL}download-receipt-pdfticket`,

		getFaclityUrl: `${baseUrl}pave-web-get-facility-rate`,

		postUrlForPayment: `${baseUrl}pave-make-web-ungated-checkin-payment`,

		// End Current Parking
		endParking: `${configDetails?.baseURL}pave-end-session`,
		getExtendDetails: `${baseUrl}pave-extend-payment-details`,
		postExtendDays: `${baseUrl}pave-days-amount`,
		postExtendSubmit: `${baseUrl}pave-make-extend-payment`,
		getTicketDownloadUrl: `${baseUrl}download-receipt-pdfticket`,

		singupUrl: `${baseUrl}sign-up`,

		sendEmailResetPassword: `${baseUrl}user/reset-password/email`,
		// GET EXTEND LIST
		getExtendList: `${configDetails?.baseURL}get-ticket-extend-list`,

		//reservation 
		// Promo code apply
		applyPromoCode: `${baseUrl}validate_promocode`,
		//payment Initial Session API
		saveReservationPaymentUrl: `${baseUrl}pave-user-reservation-guest`,
		// GET PARTNER DETAILS BY SLUG
		getPartnerBySlug: `${mainBaseUrl}partner-details-by-slug`,

		// GET Price DETAILS BY Time
		// getPriceByTime: `${baseUrl}rate/facility-on-marker`,//old api 
		getPriceByTime: `${baseUrl}rate/get-reservation-rate`,//PIMS-6682 100 % promocode consume for extend case
		downloadBookingEticketUrl: `${configDetails?.baseURL}aaa-download-booking-pdf-guest`,
		downloadPassQrcodeRequestUrl: `${configDetails?.baseURL}download-passes`,
		//getCheckInGateUrl: `${baseUrl}facility-entry-gates`,
		getCheckInGateUrl: `${baseUrl}cruise`,
		getVehicleDetailsUrl: `${baseUrl}get-all-make-models`,

		getBookingDataByID: `${baseUrl}reservation-booking-details`,

		getCancelBookinhUrl: `${baseUrl}cancel-reservation-by-user`,

		updateReservationURL: `${baseUrl}pave-user-reservation-update`,
		yankeesPermitBookingURL: `${baseUrl}diamond-user-permit-request`,
		getPermitRequestUrl: `${baseUrl}user-permit-request-list`,


		// Invoice Api--

		getinvoicePermitList: `${baseUrl}get-user-active-permiits`,

		downloadInvoiceDoc: `${baseUrl}download-user-permit`,

		// permit renewval api

		permitrenewapi: `${baseUrl}make-permit-renew-payment`,
		getPermitRequestApi: `${baseUrl}payment-permit-request`,
		paymentPermitRequestApi: `${baseUrl}customer-permit-payment`,



		updateMobileNumber: `${configDetails?.baseURL}update-phone-number-by-ticket`,
		getPermitCategoryListUrl: `${baseUrl}get-permit-categories`,
		getPermitCategoryServiceUrl: `${baseUrl}get-permit-services`,
		getWarningDetail: `${configDetails?.baseURL}get-warnings`,

		// CHECK USER VALIDITY
		checkUserValidityUrl: `${configDetails?.baseURL}get-validated-user`,

		// Download Event Ticket
		downloadQrcodeRequestUrl: `${baseUrl}mapco-download-qrcode`,
		permitAddServiceapi: `${baseUrl}add-user-permit-service`,

		// Inventory Update after reservation
		inventoryUpdatereservation: `${baseUrl}update-reservation-availability`,

		updateDefaultCard: `${baseUrl}update-default-card`,
		getPermitTypeByEMailURL: `${configDetails?.baseURL}get-permit-rate-by-email`,


		getapplePermitPassDownload: `${configDetails?.baseURL}genarate-permit-apple-wallet-pass`,
		getGooglePermitPassDownload: `${configDetails?.baseURL}genarate-permit-google-wallet-pass`,

		getappleReservationPassDownload: `${configDetails?.baseURL}genarate-reservation-apple-wallet-pass`,
		getGoogleReservationPassDownload: `${configDetails?.baseURL}genarate-reservation-google-wallet-pass`,

		getApplePassWalletDownload: `${configDetails?.baseURL}genarate-pass-apple-wallet-pass`,
		getGooglePassWalletDownload: `${configDetails?.baseURL}genarate-pass-google-wallet-pass`,

		// GET DOCUMENT TYPE
		getDocumentTypeUrl: `${configDetails?.baseURL}diamond-document-type`,

		// GET PARKING TYPE
		getParkingTypeUrl: `${configDetails?.baseURL}parking-types`,

		// GET VALIDATION CODES
		getValidationCodesUrl: `${configDetails?.baseURL}validation-codes`,

		// EOS-740
		findReservationApi: `${baseUrl}reservation-by-booking-number`,
		// EOS-740

		// EOS-852 key card change
		keycardReplacementRequest: `${baseUrl}keycard-replacement-request`,
		keycardReplacementDetails: `${baseUrl}keycard-replacement-details`,

	}
}

export const APICONFIG = new Proxy({}, {
	get(target, prop) {
		const cfg = getConfig()   // ✅ always fetch latest config
		return cfg[prop]          // ✅ return dynamic value
	}
})


